import { render, staticRenderFns } from "./inputCurrency.vue?vue&type=template&id=7187c53e"
import script from "./inputCurrency.vue?vue&type=script&lang=js"
export * from "./inputCurrency.vue?vue&type=script&lang=js"
import style0 from "./inputCurrency.vue?vue&type=style&index=0&id=7187c53e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports